import * as React from "react";
var Alert = function Alert(_ref) {
  var id = _ref.id,
    title = _ref.title,
    onClose = _ref.onClose;
  return React.createElement("div", {
    id: id,
    className: "Toaster__alert"
  }, typeof title === "string" ? React.createElement("div", {
    className: "Toaster__alert_text"
  }, title) : title, onClose && React.createElement(Close, {
    onClose: onClose
  }));
};
var Close = function Close(_ref2) {
  var onClose = _ref2.onClose;
  return React.createElement("button", {
    className: "Toaster__alert_close",
    type: "button",
    "aria-label": "Close",
    onClick: onClose
  }, React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"));
};
export default Alert;